import React from 'react';
import Routes from './Router/index';
import { Router } from 'react-router-dom';
import history from './history';
import Wrapper from './Component/Wrapper';
import GlobalContextProvider from './utils/ContextProviders/GlobalContextProvider';
import AppThemeProvider from './AppThemeProvider';
import { AuthContextProvider } from './utils/ContextProviders/AuthContextProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import SocketBootstrap from './Component/SocketBootstrap';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router history={history}>
        <AuthContextProvider>
          <GlobalContextProvider>
            <AppThemeProvider>
              <SocketBootstrap />
              <Wrapper>
                <Routes />
              </Wrapper>
            </AppThemeProvider>
          </GlobalContextProvider>
        </AuthContextProvider>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
